import { setupApiClient } from "../../../../../../services/api";


export const api = setupApiClient();